import { QuestionPlanPreQuestions } from "./pre-questions/pre-questions";

export const QuestionPlanPreQuestionsRoot = () => {
	return <QuestionPlanPreQuestions />;
};

QuestionPlanPreQuestionsRoot.displayName = "QuestionPlanPreQuestionsRoot";
